if (!customElements.get('valrenna2-color-selector')) {
  customElements.define(
    'valrenna2-color-selector',
    class Valrenna2ColorSelector extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        if (!this.dataset.productTags.includes('colori-valrenna2')) return;

        this.productId = this.dataset.productId;
        this.storageKey = `valrenna2-color-selection-${this.productId}`;
        
        this.colorTableUrl = this.dataset.colorTableUrl;
        this.assetBaseUrl = this.colorTableUrl.substring(0, this.colorTableUrl.lastIndexOf('/') + 1);
        this.colorData = null;

        // Elementi UI
        this.inputGroup = this.querySelector('.valrenna2-input-group');
        this.colorInputDisplay = this.querySelector('.valrenna2-color-display');
        this.colorInputReal = this.querySelector('.valrenna2-color-real');
        this.selectedPreviewContainer = this.querySelector('.valrenna2-selected-preview');
        this.toggleBtn = this.querySelector('.valrenna2-toggle-btn');
        this.clearBtn = this.querySelector('.valrenna2-clear-btn');
        
        // Elementi Modale
        this.modalOverlay = this.querySelector('.valrenna2-modal-overlay');
        this.modalCloseBtn = this.querySelector('.valrenna2-modal-close');
        this.colorSwatchContainer = this.querySelector('.color-swatch-container');

        this.initialize();
      }

      async initialize() {
        this.setupEventListeners();
        
        try {
          await this.fetchColorData();
          this.renderColorSwatches();
          this.restoreSelection();
          this.updateToggleButton();
        } catch (error) {
          console.error('Valrenna2 Color Selector: Initialization failed', error);
          if (this.toggleBtn) this.toggleBtn.textContent = 'Errore nel caricamento dati';
        }
      }

      async fetchColorData() {
        if (this.colorData) return;
        try {
          const response = await fetch(this.colorTableUrl);
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          this.colorData = await response.json();
        } catch (error) {
          console.error('Error fetching color data:', error);
          throw error;
        }
      }

      setupEventListeners() {
        this.toggleBtn.addEventListener('click', () => this.openModal());
        this.modalCloseBtn.addEventListener('click', () => this.closeModal());
        this.modalOverlay.addEventListener('click', (event) => {
          if (event.target === this.modalOverlay) this.closeModal();
        });

        this.clearBtn.addEventListener('click', () => this.clearSelection());

        this.colorSwatchContainer.addEventListener('click', (event) => {
          const swatch = event.target.closest('.color-swatch');
          if (swatch) {
            this.updateSelection(swatch.dataset.colorName);
            this.closeModal();
          }
        });
      }
      
      updateSelection(colorName) {
        this.colorInputReal.value = colorName;
        sessionStorage.setItem(this.storageKey, colorName);
        this.renderSelectedPreview(colorName);
      }

      clearSelection() {
        this.colorInputReal.value = '';
        sessionStorage.removeItem(this.storageKey);
        this.selectedPreviewContainer.innerHTML = '';
        this.inputGroup.classList.remove('has-selection');
      }

      restoreSelection() {
        const savedColor = sessionStorage.getItem(this.storageKey);
        if (savedColor && this.colorData) {
           this.updateSelection(savedColor);
        }
      }

      renderSelectedPreview(colorName) {
        if (!this.colorData) return;
        
        const color = this.colorData.colori.find(c => c.codice === colorName);
        
        if (!color) {
            console.warn(`Colore ${colorName} non trovato nei dati.`);
            this.clearSelection();
            return;
        }

        const imageUrl = this.assetBaseUrl + color.path;

        this.inputGroup.classList.add('has-selection');
        this.selectedPreviewContainer.innerHTML = `
            <div class="color-swatch" style="background-image: url('${imageUrl}'); width: 100%; height: 100%; cursor: default;" title="${color.codice}">
                <div class="color-swatch-inner" style="width: 100%;">
                    ${color.codice}
                </div>
            </div>
        `;
      }

      updateToggleButton() {
        this.toggleBtn.textContent = 'Mostra Tabella Colori';
        this.toggleBtn.disabled = false;
      }

      openModal() {
        if (!this.modalOverlay) return;
        document.body.style.overflow = 'hidden';
        this.modalOverlay.classList.add('is-visible');
      }

      closeModal() {
        if (!this.modalOverlay) return;
        document.body.style.overflow = '';
        this.modalOverlay.classList.remove('is-visible');
      }

      renderColorSwatches() {
        if (!this.colorData || !this.colorSwatchContainer) return;

        const colors = this.colorData.colori;
        this.colorSwatchContainer.innerHTML = '';

        if (colors.length === 0) {
          this.colorSwatchContainer.innerHTML = '<p style="padding:10px; width:100%;">Nessun colore trovato.</p>';
          return;
        }

        colors.forEach((color) => {
          const swatch = document.createElement('div');
          swatch.className = 'color-swatch';
          
          const imageUrl = this.assetBaseUrl + color.path;
          swatch.style.backgroundImage = `url('${imageUrl}')`;

          swatch.dataset.colorName = color.codice;
          swatch.title = `${color.codice}`;

          const swatchInner = document.createElement('div');
          swatchInner.className = 'color-swatch-inner';
          swatchInner.innerHTML = `
            ${color.codice}
          `;
          swatch.appendChild(swatchInner);

          this.colorSwatchContainer.appendChild(swatch);
        });
      }
    }
  );
}
